import { FetchAPI, ParamsSerializer } from './auth-service';

const fields = [
    {
        variable: 'username',
        hidden: false,
        headerName: 'Username',
        field: 'username',
        type: 'string',
    },
    {
        variable: 'name',
        hidden: false,
        headerName: 'Display Name',
        field: 'name',
        defaultSort: 'asc',
        type: 'string',
    },
    {
        variable: 'email',
        hidden: false,
        headerName: 'Email',
        field: 'email',
        type: 'string',
    },
    {
        variable: 'access',
        hidden: false,
        headerName: 'Type',
        field: 'type',
        type: 'string',
    },
    {
        variable: 'roles',
        hidden: false,
        headerName: 'Roles',
        field: 'role_sample',
        type: 'string',
        sortable: false,
    },
];

const HOME_PAGES = process.env.BRICATA_APPLIANCE_TYPE === 'mc2' ? [
    { value: '/', name: 'Dashboard' },
    { value: '/cmcs', name: 'CMCs' },
    { value: '/system/users_roles', name: 'Users' },
    { value: '/system/audit', name: 'Audit' },
] : [
    { value: '/', name: 'Dashboard' },
    { value: '/views/alerts', name: 'Alerts' },
    { value: '/views/metadata', name: 'Metadata' },
    { value: '/sensors', name: 'Sensors' },
    { value: '/system/users_roles', name: 'Users' },
    { value: '/system/audit', name: 'Audit' },
];

class UsersDataService {
    constructor () {
        // we only need one of these
        if (!UsersDataService.instance) {
            UsersDataService.instance = this;
        }
        this.searchPlaceholder = 'Search users';
        this.fields = fields;

        this.createUser = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'users/',
                body: data
            });
        };

        this.getUserData = (data) => {
            return FetchAPI({
                method: 'GET',
                url: 'users/',
                body: data
            }).then(res => {}, err => console.error(err));
        };

        this.resetPassword = (username) => {
            return FetchAPI({
                method: 'PUT',
                url: `users/${username}/reset-password`,
            });
        };

        this.setPassword = (username, data) => {
            return FetchAPI({
                method: 'PUT',
                url: `users/${username}/set-password`,
                body: data,
            });
        };

        this.emailSupport = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'users/email-req',
                body: data
            }).then(res => {}, err => console.error(err));
        };

        this.getUser = (username) => {
            return FetchAPI({
                method: 'GET',
                url: `users/${username}`,
            });
        };

        this.getSelf = () => {
            return FetchAPI({
                method: 'GET',
                url: 'users/-self/'
            }).then(res => res.object);
        };

        this.updateUser = (username, data) => {
            return FetchAPI({
                method: 'PUT',
                url: `users/${username}`,
                body: data
            });
        };

        this.deleteUser = (username) => {
            return FetchAPI({
                method: 'DELETE',
                url: `users/${username}`,
            });
        };

        this.banUser = (user) => {
            const data = user.data || {};
            data.ban = (new Date().toISOString());
            return FetchAPI({
                method: 'PUT',
                url: `users/${user.username}`,
                body: { ...user, data }
            });
        };

        this.unbanUser = (user) => {
            const data = user.data || {};
            data.ban = '';
            return FetchAPI({
                method: 'PUT',
                url: `users/${user.username}`,
                body: { ...user, data }
            });
        };

        this.enableGraceUser = (graceUser) => {
            return FetchAPI({
                method: 'PUT',
                url: `users/${graceUser}/grace/`,
            }).then(res => {}, err => console.error(err));
        };

        this.disableGraceUser = (graceUser) => {
            return FetchAPI({
                method: 'DELETE',
                url: `users/${graceUser}/grace/`,
            }).then(res => {}, err => console.error(err));
        };

        this.havePerms = (username) => {
            return FetchAPI({
                method: 'GET',
                url: `users/${username}/perms`,
            });
        };

        this.getUsers = (search, query) => {
            let params = { limit: 10000 };
            if (query) {
                params = {
                    ...params,
                    sort: `${query.orderBy.variable}:${query.orderDirection}`,
                    offset: query.page * query.pageSize,
                    q: search,
                };
            } else if (search) {
                params = {
                    ...params,
                    q: search,
                };
            }
            return FetchAPI({ method: 'GET', url: `users/?${ParamsSerializer(params)}` })
                .then(res => {
                    if (!res) res = { objects: [] };
                    self.asof = res.timestamp;
                    this.data = res.objects || [];

                    return {
                        data: this.data,
                        page: query ? query.page : 1,
                        totalCount: this.total || (res.objects || []).length,
                    };
                });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_users') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_users', JSON.stringify(searches));
        };

        return UsersDataService.instance;
    }
}

const UsersService = new UsersDataService();

export {
    UsersService as default,
    fields as userFields,
    HOME_PAGES,
};
